/**
 * 共通受付照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 請求先情報
 */
export interface Sgkb575aResClmtoInfo {
    /** 
     * 支払方法コード：半角数字
     */
    payMthdiv?: string;
    /** 
     * 支払方法コード名称：全角半角混在
     */
    payMthdivAname?: string;
    /** 
     * 請求先お客さま漢字氏名：全角文字
     */
    clmtoName?: string;
    /** 
     * 請求先お客さまカナ氏名：全角カナ
     */
    clmtoKanaName?: string;
    /** 
     * 請求先お客さま電話番号コード１：半角英数混在
     */
    clmtoTeldv1?: string;
    /** 
     * 請求先お客さま電話番号コード１名称：全角半角混在
     */
    clmtoTeldv1Aname?: string;
    /** 
     * 請求先お客さま電話番号１：電話番号(ハイフンと数値含む)
     */
    clmtoTelNo1?: string;
    /** 
     * 請求先お客さま電話番号コード２：半角英数混在
     */
    clmtoTeldv2?: string;
    /** 
     * 請求先お客さま電話番号コード２名称：全角半角混在
     */
    clmtoTeldv2Aname?: string;
    /** 
     * 請求先お客さま電話番号２：電話番号(ハイフンと数値含む)
     */
    clmtoTelNo2?: string;
    /** 
     * 請求先お客さま電話番号コード３：半角英数混在
     */
    clmtoTeldv3?: string;
    /** 
     * 請求先お客さま電話番号コード３名称：全角半角混在
     */
    clmtoTeldv3Aname?: string;
    /** 
     * 請求先お客さま電話番号３：電話番号(ハイフンと数値含む)
     */
    clmtoTelNo3?: string;
    /** 
     * 請求先住所コード：半角英数混在
     */
    clmtoAddrcd?: string;
    /** 
     * 請求先郵便番号：半角数字
     */
    clmtoPostno?: string;
    /** 
     * 請求先都道府県名称：全角文字
     */
    clmtoPfcAname?: string;
    /** 
     * 請求先市区郡町村名称：全角文字
     */
    clmtoMptAname?: string;
    /** 
     * 請求先町域名称：全角文字
     */
    clmtoTwareaAname?: string;
    /** 
     * 請求先大字丁目名称：全角文字
     */
    clmtoOazaAname?: string;
    /** 
     * 請求先住所番地・号・分筆号：全角文字
     */
    clmtoAddrBlockgoulot?: string;
    /** 
     * 請求先住所住宅・棟号漢字名：全角文字
     */
    clmtoAddrAddressaname?: string;
    /** 
     * 請求先住所屋号・業種漢字名：全角文字
     */
    clmtoAddrYagou?: string;
    /** 
     * 請求先表示住所漢字：全角文字
     */
    clmtoAddrAnameF?: string;
    /** 
     * 請求先住所手入力フラグ：半角数字
     */
    clmtoAddressinputflag?: string;
    /** 
     * 請求先住所手入力フラグ名称：全角半角混在
     */
    claimtoaddressInputFlganame?: string;
    /** 
     * 請求先住所郵便番号：全角文字
     */
    clmtoAddresspostno?: string;
    /** 
     * 請求先住所都道府県：全角文字
     */
    clmtoAddressprefecture?: string;
    /** 
     * 請求先住所行政市区：全角文字
     */
    clmtoAddressadminstcity?: string;
    /** 
     * 請求先住所行政町名：全角文字
     */
    clmtoAddressadminstchoname?: string;
    /** 
     * 請求先住所丁目：全角文字
     */
    clmtoAddresschome?: string;
}
